!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.ReactSlideToggle = t(require("react")) : e.ReactSlideToggle = t(e.React);
}(window, function (e) {
  return function (e) {
    var t = {};
    function a(o) {
      if (t[o]) return t[o].exports;
      var r = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, a), r.l = !0, r.exports;
    }
    return a.m = e, a.c = t, a.d = function (e, t, o) {
      a.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, a.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, a.t = function (e, t) {
      if (1 & t && (e = a(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (a.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) a.d(o, r, function (t) {
        return e[t];
      }.bind(null, r));
      return o;
    }, a.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return a.d(t, "a", t), t;
    }, a.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, a.p = "/", a(a.s = 4);
  }([function (t, a) {
    t.exports = e;
  }, function (e, t) {
    var a;
    a = function () {
      return this;
    }();
    try {
      a = a || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" == typeof window && (a = window);
    }
    e.exports = a;
  }, function (e, t, a) {
    "use strict";

    (function (e) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o,
        r = function () {
          function e(e, t) {
            for (var a = 0; a < t.length; a++) {
              var o = t[a];
              o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
            }
          }
          return function (t, a, o) {
            return a && e(t.prototype, a), o && e(t, o), t;
          };
        }(),
        s = a(0),
        n = (o = s, o && o.__esModule ? o : {
          default: o
        });
      var i = "undefined" != typeof window ? window : e,
        l = i.requestAnimationFrame ? i.requestAnimationFrame.bind(i) : function (e) {
          return i.setTimeout(e, 16);
        },
        p = i.cancelAnimationFrame ? i.cancelAnimationFrame.bind(i) : i.clearInterval.bind(i),
        u = {
          EXPANDED: "EXPANDED",
          COLLAPSED: "COLLAPSED",
          EXPANDING: "EXPANDING",
          COLLAPSING: "COLLAPSING"
        },
        g = function g(e) {
          return e < .5 ? 4 * e * e * e : .5 * Math.pow(2 * e - 2, 3) + 1;
        },
        c = {
          isMoving: function isMoving(e) {
            return e === u.EXPANDING || e === u.COLLAPSING;
          },
          clamp: function clamp(e) {
            var t = e.value,
              a = e.max,
              o = void 0 === a ? 1 : a,
              r = e.min,
              s = void 0 === r ? 0 : r;
            return t > o ? o : t < s ? s : t;
          },
          now: function now() {
            return new Date().getTime();
          },
          sanitizeDuration: function sanitizeDuration(e) {
            return Math.max(0, parseInt(+e, 10) || 0);
          },
          interpolate: function interpolate(e) {
            var t = e.next,
              a = e.prev,
              o = Math.abs(t - a),
              r = t;
            return o > .15 && (t > a ? r -= .75 * o : r += .75 * o), r;
          }
        },
        d = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
          }(t, n.default.Component);
          function t(e) {
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, t);
            var a = function (e, t) {
              if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return !t || "object" != typeof t && "function" != typeof t ? e : t;
            }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
            return a.getCollapsible = function () {
              return a._state_.collapsibleElement;
            }, a.updateCollapsible = function (e, t) {
              a.getCollapsible() && (a._state_.collapsibleElement.style[e] = t);
            }, a.setCollapsibleElement = function (e) {
              a._state_.collapsibleElement = e, a._state_.toggleState === u.COLLAPSED && a.setCollapsedState({
                initialState: !0
              });
            }, a.onToggle = function () {
              if (!a.props.irreversible || !c.isMoving(a._state_.toggleState)) {
                var e = function e() {
                    a.props.onCollapsing && a.props.onCollapsing({
                      range: a.state.range,
                      progress: a.state.progress,
                      hasReversed: a.state.hasReversed
                    }), a.collapse();
                  },
                  t = function t() {
                    a.props.onExpanding && a.props.onExpanding({
                      range: a.state.range,
                      progress: a.state.progress,
                      hasReversed: a.state.hasReversed
                    }), a.expand();
                  },
                  o = function o(e) {
                    var t = e.toggleState,
                      o = e.display,
                      r = e.hasReversed;
                    a._state_.toggleState = t, a._state_.hasReversed = !!r, void 0 === o || a.props.noDisplayStyle || a.updateCollapsible("display", o);
                    var s = c.now();
                    if (r) {
                      var n = a._state_.startTime,
                        i = c.sanitizeDuration(a.props.duration),
                        l = Math.min(i, s - n),
                        p = Math.max(0, i - l);
                      a._state_.startTime = s - p;
                    } else {
                      var u = a.getCollapsible();
                      u && u.style.height && a.updateCollapsible("height", null), a._state_.boxHeight = u ? u[a.GET_HEIGHT] : 0, a._state_.startTime = s, a._state_.startDirection = t;
                    }
                    a.setState({
                      toggleState: a._state_.toggleState,
                      hasReversed: a._state_.hasReversed
                    });
                  };
                a._state_.toggleState === u.EXPANDED ? (o({
                  toggleState: u.COLLAPSING
                }), e()) : a._state_.toggleState === u.COLLAPSED ? (o({
                  toggleState: u.EXPANDING,
                  display: ""
                }), t()) : a._state_.toggleState === u.EXPANDING ? (o({
                  toggleState: u.COLLAPSING,
                  hasReversed: !0
                }), e()) : a._state_.toggleState === u.COLLAPSING && (o({
                  toggleState: u.EXPANDING,
                  display: "",
                  hasReversed: !0
                }), t());
              }
            }, a.setExpandedState = function () {
              a._state_.progress = 1, a._state_.toggleState = u.EXPANDED, a.updateCollapsible("height", null), a.setState({
                toggleState: u.EXPANDED,
                range: 1,
                progress: a._state_.progress
              }), a.props.onExpanded && a.props.onExpanded({
                hasReversed: a.state.hasReversed
              });
            }, a.expand = function () {
              if (a._state_.toggleState === u.EXPANDING) {
                var e = c.sanitizeDuration(a.props.duration);
                if (e <= 0) a.setExpandedState();else {
                  var t = a._state_.startTime,
                    o = Math.min(e, c.now() - t);
                  if (o >= e) a.setExpandedState();else {
                    var r = a._state_,
                      s = r.startDirection,
                      n = r.toggleState,
                      i = r.boxHeight,
                      l = c.clamp({
                        value: o / e
                      }),
                      p = void 0;
                    p = a.props.whenReversedUseBackwardEase && s !== n ? 1 - a.props.easeCollapse(1 - l) : a.props.easeExpand(l), a.props.bestPerformance || a.setState({
                      range: l,
                      progress: p
                    }), a.props.interpolateOnReverse && a._state_.hasReversed && (p = c.interpolate({
                      next: p,
                      prev: a._state_.progress
                    }));
                    var g = Math.round(i * p);
                    a._state_.progress = p, a.updateCollapsible("height", g + "px"), a.nextTick(a.expand);
                  }
                }
              }
            }, a.setCollapsedState = function () {
              var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).initialState;
              a._state_.progress = 0, a._state_.toggleState = u.COLLAPSED, a.props.noDisplayStyle ? a.updateCollapsible("height", "0px") : (a.updateCollapsible("display", "none"), a.updateCollapsible("height", null)), a.setState({
                toggleState: u.COLLAPSED,
                range: 0,
                progress: a._state_.progress
              }), !e && a.props.onCollapsed && a.props.onCollapsed({
                hasReversed: a.state.hasReversed
              });
            }, a.collapse = function () {
              if (a._state_.toggleState === u.COLLAPSING) {
                var e = c.sanitizeDuration(a.props.duration);
                if (e <= 0) a.setCollapsedState();else {
                  var t = a._state_.startTime,
                    o = Math.min(e, c.now() - t);
                  if (o >= e) a.setCollapsedState();else {
                    var r = a._state_,
                      s = r.startDirection,
                      n = r.boxHeight,
                      i = r.toggleState,
                      l = 1 - c.clamp({
                        value: o / e
                      }),
                      p = a.props,
                      g = p.whenReversedUseBackwardEase,
                      d = p.easeExpand,
                      f = p.easeCollapse,
                      _ = void 0;
                    _ = g && s !== i ? d(l) : 1 - f(1 - l), a.props.bestPerformance || a.setState({
                      range: l,
                      progress: _
                    }), a.props.interpolateOnReverse && a._state_.hasReversed && (_ = c.interpolate({
                      next: _,
                      prev: a._state_.progress
                    }));
                    var h = Math.round(n * _);
                    a._state_.progress = _, a._state_.timeout = a.nextTick(a.collapse), a.updateCollapsible("height", h + "px");
                  }
                }
              }
            }, a.nextTick = function (e) {
              a._state_.timeout = l(e);
            }, a._state_ = {
              collapsibleElement: null,
              toggleState: a.props.collapsed ? u.COLLAPSED : u.EXPANDED
            }, a.GET_HEIGHT = e.scrollHeight ? "scrollHeight" : "offsetHeight", a.state = {
              toggleState: a._state_.toggleState,
              hasReversed: !1,
              range: a.props.collapsed ? 0 : 1,
              progress: a.props.collapsed ? 0 : 1
            }, a;
          }
          return r(t, [{
            key: "render",
            value: function value() {
              var e = {
                onToggle: this.onToggle,
                setCollapsibleElement: this.setCollapsibleElement,
                toggleState: this.state.toggleState,
                hasReversed: this.state.hasReversed,
                isMoving: c.isMoving(this.state.toggleState),
                range: this.state.range,
                progress: this.state.progress
              };
              return this.props.children ? this.props.children(e) : this.props.render ? this.props.render(e) : null;
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              p(this._state_.timeout);
            }
          }]), t;
        }();
      d.defaultProps = {
        duration: 300,
        easeCollapse: g,
        easeExpand: g
      }, t.default = d;
    }).call(this, a(1));
  }, function (e, t, a) {
    "use strict";

    var o = a(2).default;
    e.exports = {
      SlideToggle: o
    };
  }, function (e, t, a) {
    e.exports = a(3);
  }]);
});